/**
 * @returns reordered chart data based on field orders inside chart axes
 */
export const reorderChartData = (chartData: any[], chartAxes: any[]): any[] => {
  if (!chartData || chartData.length === 0) {
    return chartData;
  }

  const orderedFieldNames: string[] = [];

  chartAxes.forEach((axis: any) => {
    if (axis.name !== 'Filter' && axis.fields && axis.fields.length > 0) {
      axis.fields.forEach((field: any) => {
        orderedFieldNames.push(field.displayname);
      });
    }
  });

  const tempChartData = JSON.parse(JSON.stringify(chartData));
  const reorderedChartdata: any[] = [];

  for (let i = 0; i < tempChartData.length; i++) {
    let tempRowObject: { [key: string]: string | number } = {};
    orderedFieldNames.forEach(
      (fieldName: string) => (tempRowObject[fieldName] = tempChartData[i][fieldName]),
    );
    reorderedChartdata.push(tempRowObject);
  }
  return reorderedChartdata;
};
